export function isFiniteBrandId(id: number | undefined | null): id is number {
  return typeof id === "number" && Number.isFinite(id);
}

export function parseMetaSelectedBrandId(raw: unknown): number | undefined {
  if (raw == null || raw === "") return undefined;
  const n = Number(raw);
  return Number.isFinite(n) ? n : undefined;
}
